import { FC } from "react";
import { TGlobalSearchTermSearchResultTermHit } from "Types";
import { SearchTermValue } from "./SearchTermValue";

type TSearchTermTermHitProps = {
    termHit: TGlobalSearchTermSearchResultTermHit,
    onSingleItemClick?: (text: string) => void
}

export const SearchTermTermHit: FC<TSearchTermTermHitProps> = ({ termHit, onSingleItemClick }: TSearchTermTermHitProps) => {

    return (
        <SearchTermValue value={termHit.text} onSingleItemClick={onSingleItemClick}/>
    );

};